import React, { useContext, useEffect, useState } from "react";
import { alpha } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { createTheme } from "@mui/material";
import DateFnsUtils from '@date-io/date-fns';
import Button from "@mui/material/Button";
import InfoIcon from '@mui/icons-material/Info';
import {format} from 'date-fns';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import IconButton from '@mui/material/IconButton';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
  KeyboardTimePicker,
  DatePicker
} from '@material-ui/pickers';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
import EventIcon from '@mui/icons-material/Event';
import MobileTimePicker from '@mui/lab/MobileTimePicker';


const materialTheme = createTheme(({
  // set default for now
}));
const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%"
},

}));

export default function InputInventoryDialog(props) {
  const classes = useStyles();

 
  const [selectedDate,setSelectedDate] = React.useState(null);
  const [expiryDateCalenderOpen, setExpiryDateCalenderOpen] = useState(false);
  const [selectedUomIndex,setSelectedUomIndex] = useState(0)
  
  const [quantity,setQuantity] = useState(-1)
  const [uom,setUom] = useState()
  const [lotNumber,setLotNumber] = useState("")
  const [expiryDate, setExpiryDate] = useState();
  const [openInventoryExistsConfirmationDialog,setOpenInventoryExistsConfirmationDialog] = useState(false)
  const [existsInventoryAction, setExistsInventoryAction] = useState("Add quantity");
  const [openExpiryDateCalenderDialog,setOpenExpiryDateCalenderDialog] = useState(false)


  const onInventoryExistsDialogRadioGroupChange = (event) => {
   
    setExistsInventoryAction(event.target.value);
  };

  const inventoryExistsConfirmationDialogDoneBtnClick = ()=>{

    const expirationDate = expiryDate ? format(expiryDate, 'yyyy-MM-dd'):""
    const existingInputtedInventory = getInputtedInventory(props.selectedProduct.code,uom.uom,lotNumber,expirationDate)
    
    if(existsInventoryAction == "Add quantity"){
      //add inventory
      existingInputtedInventory.quantity = existingInputtedInventory.quantity + parseInt(quantity)

    }else{
      //replace inventory
      existingInputtedInventory.quantity = parseInt(quantity)
    }

    const inputtedInventories = [...props.selectedProduct.InputtedInventories]
    const inputtedInventoryIndex = inputtedInventories.findIndex((inputtedInventory) => {
      return inputtedInventory.uom == uom.uom && inputtedInventory.lot_number == lotNumber && inputtedInventory.expiration_date == expirationDate
    });
    inputtedInventories.splice(inputtedInventoryIndex, 1, existingInputtedInventory); //replace object
    props.selectedProduct.InputtedInventories = inputtedInventories
    saveTempInvetoryCount(props.selectedProduct)

    setOpenInventoryExistsConfirmationDialog(false)
    props.onProductInputtedInventory(props.selectedProduct)
    props.setOpenInventoryAddLotNumberAndExpiration(false)
              

  }
  function inventoryExistsConfirmationDialog(){
    return(
      <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={openInventoryExistsConfirmationDialog}
      onClose={()=>{}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Inventory already exist. Select action below.
        </Typography>
        <FormControl component="fieldset">
          
          <RadioGroup aria-label="gender" name="gender1" value={existsInventoryAction} onChange={onInventoryExistsDialogRadioGroupChange}>
            <FormControlLabel value="Add quantity" control={<Radio />} label="Add quantity" />
            <FormControlLabel value="Replace quantity" control={<Radio />} label="Replace quantity" />
            
          </RadioGroup>
        </FormControl>
        
      </DialogContent>
      <DialogActions>
        <Button onClick={()=>{setOpenInventoryExistsConfirmationDialog(false)}} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={inventoryExistsConfirmationDialogDoneBtnClick} 
          color="primary" autoFocus>
          Done
        </Button>
      </DialogActions>
    </Dialog>
    )
  }

 
  function calendarDialog(){
    return(
      <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={expiryDateCalenderOpen}
      onClose={()=>{setExpiryDateCalenderOpen(false)}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      
      <DialogContent  style={{padding:'0px'}}>
     
      </DialogContent>

      <DialogActions>
        <Button onClick={()=>{setExpiryDateCalenderOpen(false)}} color="primary">
          Cancel
        </Button>
        <Button 
          onClick={()=>{
            setExpiryDate(selectedDate)
            setExpiryDateCalenderOpen(false)}
          
          } 
          color="primary" autoFocus>
          Done
        </Button>
      </DialogActions>
    </Dialog>
    )
  }
    


   function saveTempInvetoryCount(product) {
      const temporaryInventoryString = localStorage.getItem(props.companyId + "_temporary_inventory_count");
      if (temporaryInventoryString == null) {
        localStorage.setItem(props.companyId + "_temporary_inventory_count",JSON.stringify([product]))
        return;
      }

      const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);
      const productIndex = temporaryInventoryJSON.findIndex((productParam) => productParam.code == product.code);

      if (productIndex >= 0) {
        temporaryInventoryJSON.splice(productIndex, 1, product); //replace object
        
      } else {
        temporaryInventoryJSON.push(product)
        
      }
      localStorage.setItem(props.companyId+ "_temporary_inventory_count",JSON.stringify(temporaryInventoryJSON))
     
    }

    function getInputtedInventory(productCode,UOM,lotNumber,expirationDate){
      const temporaryInventoryString = localStorage.getItem(props.companyId + "_temporary_inventory_count");
      if (temporaryInventoryString == null) {
        return
      }

      const temporaryInventoryJSON = JSON.parse(temporaryInventoryString);    
      const productIndex = temporaryInventoryJSON.findIndex((productParam) => productParam.code == productCode);
      if(productIndex < 0){
        return 
      }

      const product = temporaryInventoryJSON[productIndex]

      if(!product.InputtedInventories || product.InputtedInventories.length <=0){
        return
      }

      const inputtedInventories = product.InputtedInventories

      const inputtedInventoryIndex = inputtedInventories.findIndex((inputtedInventory) => {
        return inputtedInventory.uom == UOM && inputtedInventory.lot_number == lotNumber && inputtedInventory.expiration_date == expirationDate
      });

      if(inputtedInventoryIndex < 0){
        return 
      }
      
      return inputtedInventories[inputtedInventoryIndex]

    }

    useEffect(()=>{
      console.log("EXISTING "+existsInventoryAction)
  
    },[existsInventoryAction])

    if(!props.selectedProduct){
      return("")
  
    }
    
    return (
      <div>
        <Dialog
         fullWidth={true}
         maxWidth="md"
          open={props.openInventoryAddLotNumberAndExpiration}
          onClose={() => {setExpiryDateCalenderOpen(false)}}
          aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">{props.selectedProduct.name}</DialogTitle>
          <DialogContent>
              <Grid container spacing={1}>
                <Grid  container >
                    <Grid item xs={5}>
                      Quantity
                    </Grid>
                    <Grid item xs>
                     UOM
                    </Grid>
                </Grid>

                <Grid  container >
                    <Grid item xs={5}>
                      <TextField
                          style={{width:'100%'}}
                          name={"dm_contact_name"}
                          id="contact-name"
                          type="number" 
                          variant="outlined"
                          onChange={(event)=>{
                            const quantityValue = event.target.value
                            setQuantity(quantityValue ? quantityValue: -1)
                
                          }}
                      />
                    </Grid>
                    <Grid item xs>
                    <Select
                     className={classes.fullWidth}
                        variant="outlined"
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        value={!uom ? "" :uom }
                        onChange={(event)=>{
                          
                          console.log(event.target.value)

                          setUom(event.target.value)
                         
                        }}
                        >
                          {
                            props.selectedProduct.Units.map((unit,index)=>{
                              
                              return(
                                <MenuItem  key={unit.id}  value={unit}>{unit.uom}</MenuItem>
                              )
                              
                            })
                          }
                   
                   
                    </Select>
                    </Grid>
                </Grid>
                <Grid item xs={12} >Lot #</Grid>
                <Grid item xs={12}>
                    <TextField
                        name={"lot_number"}
                        className={classes.fullWidth}
                        id="lot-number"
                        rows={4}
                        variant="outlined"
                        onChange={(event)=>{
                          setLotNumber(event.target.value)
                          
                        }}
                    />
                </Grid>
                <Grid item xs={12} >Expiry date</Grid>
                <Grid item container  >
                <StyledEngineProvider injectFirst>
                  <ThemeProvider theme={materialTheme}>
              
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                          <MobileDatePicker
                              onAccept={(date)=>{
                                if(date != null){
                                  setSelectedDate(date)
                                  setExpiryDate(date)
                                }
                               
                              }}          
                              inputFormat="MMMM d, yyyy"
                              value={selectedDate}
                              open={openExpiryDateCalenderDialog}
                              onChange={(date)=>{ }}
                              onOpen={()=>{setOpenExpiryDateCalenderDialog(true)}}
                              onClose={()=>{setOpenExpiryDateCalenderDialog(false)}}
							  minDate={new Date()}
                              renderInput={(params) => 
                                <TextField 
                                  {...params} 
                                  className={classes.fullWidth} 
                                  InputProps={{
                                  endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton edge="end" onClick={()=>{setOpenExpiryDateCalenderDialog(true)}}>
                                            <EventIcon />
                                        </IconButton>
                                      </InputAdornment>
                                      ),
                                    }}
                                  />
                                }
                              />
                      </LocalizationProvider>
                    </ThemeProvider>
                </StyledEngineProvider>  
                </Grid>
           
              </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => {
              props.setOpenInventoryAddLotNumberAndExpiration(false)
            }} color="primary">
              Cancel
            </Button>
            <Button onClick={() => {

              if(quantity < 0){
                alert("Please provide quantity.")
                return;
              }

              if(!uom || uom.uom ===""){
                alert("Please select UOM")
                return
              }

              const alphanumericRegex = /^[a-zA-Z0-9]*$/;
              if (!alphanumericRegex.test(lotNumber)) {
                setLotNumber('');
                alert('Alphanumeric only is allowed in lot #');
                return;
              }

              const expirationDate = expiryDate ? format(expiryDate, 'yyyy-MM-dd'):""
              const existingInputtedInventory = getInputtedInventory(props.selectedProduct.code,uom.uom,lotNumber,expirationDate)
              
               if(existingInputtedInventory){
                setOpenInventoryExistsConfirmationDialog(true)
                return
               }
             
               const inputtedInventory = {
                'quantity':parseInt(quantity),
                'uom':uom.uom,
                'conversion_to_smallest_uom':parseInt(uom.converted_to_smallest_value),
                'lot_number':lotNumber,
                'expiration_date':expirationDate
              }

              const productInputtedInventory = props.selectedProduct.InputtedInventories ? props.selectedProduct.InputtedInventories :[]
              productInputtedInventory.push(inputtedInventory)

             
              props.selectedProduct.InputtedInventories = productInputtedInventory
              
              saveTempInvetoryCount(props.selectedProduct)
              
              props.onProductInputtedInventory(props.selectedProduct)
              props.setOpenInventoryAddLotNumberAndExpiration(false)
              
             
              
            }} color="primary">
              Done
            </Button>
          </DialogActions>
          {inventoryExistsConfirmationDialog()}
        </Dialog>
        {calendarDialog()}
        
        </div>
    );
}